import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import BandeauAdherent from './components/BandeauAdherent';
import Suggestions from './components/Suggestions';
import Messages from './components/Messages';
import SaisieZone from './components/SaisieZone';
import ModalConfig from './components/ModalConfig';
import EcranConnexion from './components/EcranConnexion';
import { useConfig } from './hooks/useConfig';
import { useChat } from './hooks/useChat';
import { useAuth } from './hooks/useAuth';
import './App.css';

export default function App() {
  const { config, sauvegarder } = useConfig();
  const { adherent, loading, erreur, connecter, deconnecter } = useAuth(config);
  const { messages, enCours, fichiers, ajouterFichiers, supprimerFichier, envoyer, vider } = useChat(config, adherent);
  const [configOuverte, setConfigOuverte] = useState(false);

  // ── Pull-to-refresh uniquement sur l'écran de connexion ──
  useEffect(() => {
    if (adherent) return; // désactivé une fois connecté
    let startY = 0;
    const onTouchStart = (e) => { startY = e.touches[0].clientY; };
    const onTouchEnd = (e) => {
      const dy = e.changedTouches[0].clientY - startY;
      if (dy > 80 && window.scrollY === 0) {
        window.location.reload();
      }
    };
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }, [adherent]);

  const handleVider = () => {
    if (window.confirm('Effacer toute la conversation ?')) vider();
  };

  const handleDeconnecter = () => {
    if (window.confirm('Se déconnecter ?')) {
      deconnecter();
      vider();
    }
  };

  // ── Écran de connexion si non authentifié ──
  if (!adherent) {
    return (
      <div className="app">
        <EcranConnexion
          onConnecter={connecter}
          loading={loading}
          erreur={erreur}
          onOuvrirConfig={() => setConfigOuverte(true)}
        />
        {configOuverte && (
          <ModalConfig
            config={config}
            onSauvegarder={sauvegarder}
            onFermer={() => setConfigOuverte(false)}
          />
        )}
      </div>
    );
  }

  // ── Interface chat si connecté ──
  return (
    <div className="app">

      <Header
        config={config}
        onOuvrirConfig={() => setConfigOuverte(true)}
        onVider={handleVider}
      />

      <BandeauAdherent adherent={adherent} onDeconnecter={handleDeconnecter} />

      {!config.url && (
        <div className="alerte" onClick={() => setConfigOuverte(true)}>
          ⚠️ Webhook non configuré — Appuyez ici pour configurer
        </div>
      )}

      <Suggestions onSelect={envoyer} />

      <Messages messages={messages} nomAssistant={config.nom} />

      <SaisieZone
        onEnvoyer={envoyer}
        fichiers={fichiers}
        onAjouterFichiers={ajouterFichiers}
        onSupprimerFichier={supprimerFichier}
        enCours={enCours}
      />

      {configOuverte && (
        <ModalConfig
          config={config}
          onSauvegarder={sauvegarder}
          onFermer={() => setConfigOuverte(false)}
        />
      )}

    </div>
  );
}
